import Nav from './Nav'
import Footer from './Footer'

import ReCAPTCHA from 'react-google-recaptcha'
import React, { Component } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

import axios from 'axios'
import $ from 'jquery'

import {
	MDBInput,
	MDBDropdown,
	MDBDropdownToggle,
	MDBDropdownMenu,
	MDBDropdownItem,
	MDBIcon
} from 'mdbreact'

class App extends Component {
	constructor(props) {
		super(props)
		this.onCaptcha = this.onCaptcha.bind(this)
		this.state = {
			serverLocation: 'https://perplexed.tech',
			uniqueid: '',
			name: '',
			school: '',
			district: '',
			designation: '',
			mobile: '',
			email: '',
			location: '',
			confirm:false,
			allLocations: [],
			captcha: false
		}
	}
	async getSchool() {
		if(this.state.confirm){
			return
		}
		let uid = $('#uniqueid').attr('value')
		try {
			$('#confBut').toggleClass('submit')
			$('#loadConf').toggleClass('submit')
			let url = `${this.state.serverLocation}/atl/uid?id=${uid}`
			let schools = await axios.get(url)

			if (schools.data.status === 200) {
				$('#loadConf').addClass('submit')
				$('#check').toggleClass('submit')
				$('#buttomConfirm').removeClass('btn-primary').addClass('btn-success')
				$('#confBut').addClass('submit')

				let schoolName = schools.data.values[1]
				let cityName = schools.data.values[3]
				let stateName = schools.data.values[4]

				$('label#school').html(schoolName)
				$('label#City').html(cityName + ', ' + stateName)

				this.setState({school:`${schoolName}, ${cityName}, ${stateName}`})
				this.setState({confirm:true})
			} else {
				alert('Please check uid')
				$('#confBut').toggleClass('submit')
				$('#loadConf').toggleClass('submit')
			}
		} catch (err) {
			$('#confBut').removeClass('submit')
			$('loadConf').addClass('submit')
			console.log(err)
		}
	}

	async componentWillMount() {
		try {
			let places = await axios.get(
				`${this.state.serverLocation}/atl/places`
			)
			this.setState({ allLocations: places.data['values'] })
		} catch (err) {
			console.log(err)
		}
	}

	onCaptcha(value) {
		axios
			.post(`${this.state.serverLocation}/captcha/verify`, {
				'g-recaptcha-response': value
			})
			.then(res => {
				console.log(res.data['success'])
				if (res.data['success']) this.setState({ captcha: true })
			})
	}

	handleSubmit = event => {
		event.preventDefault()

		const user = {
			uniqueid: this.state.uniqueid,
			name: this.state.name,
			school: this.state.school,
			district: this.state.district,
			designation: this.state.designation,
			mobile: this.state.mobile,
			email: this.state.email,
			location: this.state.location,
			date: this.state.date
		}
		if (this.state.location) {
			if (this.state.captcha) {
				$('#subBut').toggleClass('submit')
				$('#loader').toggleClass('submit')

				axios
					.post(`${this.state.serverLocation}/atl`, user)
					.then(res => {
						if (res.data['success']) {
							$('#foo').toggleClass('submit')
							$('#success').toggleClass('submit')
						}
					})
					.catch(err => console.log(err))
			} else {
				window.alert('Please complete captcha.')
			}
		} else {
			window.alert('Please select location.')
			$('#naya')
				.removeClass('btn-primary')
				.toggleClass('btn-danger')
		}
	}

	render() {
		return (
			<React.Fragment>
				<Nav />
				<MDBIcon icon="check" />

				<div className="App">
					<div className="container">
						<p className="title">Atal Tinkering Labs</p>
						<div className="dabba">
							<div
								id="success"
								className="submit successFulDabba"
							>
								<div className="successFul">
									Submitted Successfully
								</div>
							</div>
							<form id="foo" onSubmit={this.handleSubmit}>
								<div className="row ">
									<div className="col-sm-9 col-md-9 col-lg-9  pr-0 mr-0 mt-0">
										<MDBInput
											label="Unique ID"
											type="text"
											name="uniqueid"
											id="uniqueid"
											value={this.state.uniqueid}
											onChange={e =>
												this.setState({
													uniqueid: e.target.value
												})
											}
											required
										/>{' '}
									</div>

									<div className="col-sm-3 col-md-3 col-lg-3  buttonConfirmDiv">
										<button
											onClick={e => {
												e.preventDefault()
												this.getSchool()
											}}
											id="buttomConfirm"
											className="   btn btn-primary btn-sm buttonConfirm"
										>
											<span id="confBut">Confirm</span>
											<div
												className="submit spinner-border"
												id="loadConf"
												role="status"
											/>
											<FontAwesomeIcon
												icon={faCheck}
												// size="fa-lg"
												id='check'
												className='fa-2x submit'
											/>
										</button>
									</div>
								</div>
								<div className="row ">
									<div className="col-sm-12 col-md-6 col-lg-6 mt-0">
										<MDBInput
											label="School"
											disabled
											background
											className="inputDisabled"
											type="text"
											name="school"
											id="school"
											// value={this.state.school}
											// onChange={e =>
											// 	this.setState({
											// 		// school: e.target.value
											// 	})
											// }
											required
										/>{' '}
									</div>
									<div className="col-sm-12 col-md-6 col-lg-6 mt-0  ">
										<MDBInput
											label="City"
											type="text"
											disabled
											name="City"
											id="City"
											background
											className="inputDisabled"
											value={this.state.District}
											onChange={e =>
												this.setState({
													District: e.target.value
												})
											}
											required
										/>{' '}
									</div>
								</div>
								<MDBInput
									label="Name"
									type="text"
									name="name"
									id="name"
									value={this.state.name}
									onChange={e =>
										this.setState({
											name: e.target.value
										})
									}
									required
								/>
								<MDBInput
									label="Designation"
									type="text"
									name="designation"
									id="designation"
									value={this.state.designation}
									onChange={e =>
										this.setState({
											designation: e.target.value
										})
									}
									required
								/>{' '}
								<MDBInput
									label="Contact Number"
									type="number"
									name="mobile"
									id="mobile"
									value={this.state.mobile}
									onChange={e =>
										this.setState({
											mobile: e.target.value
										})
									}
									required
								/>{' '}
								<MDBInput
									label="E-Mail"
									type="email"
									name="email"
									id="email"
									value={this.state.email}
									onChange={e =>
										this.setState({
											email: e.target.value
										})
									}
									required
								/>{' '}
								<MDBDropdown dropright className="dropdown">
									<MDBDropdownToggle
										caret
										color="primary"
										id="naya"
										onClick={e =>
											$('#naya')
												.removeClass('btn-danger')
												.addClass('btn-primary')
										}
									>
										Select Event Location
									</MDBDropdownToggle>
									<MDBDropdownMenu basic>
										{this.state.allLocations.map(elem => {
											return (
												<MDBDropdownItem
													key={elem[0]}
													onClick={e => {
														this.setState({
															location: elem[1],
															date: elem[2]
														})
														$('#date').attr(
															'value',
															elem[2]
														)
													}}
												>
													{elem[1]}
												</MDBDropdownItem>
											)
										})}
									</MDBDropdownMenu>{' '}
									{this.state.location || 'Select Venue'}
								</MDBDropdown>
								<MDBInput
									label="Date"
									type="date"
									name="date"
									className="date"
									id="date"
									value={this.state.date}
									onChange={e =>
										this.setState({
											date: e.target.value
										})
									}
									required
									disabled
								/>{' '}
								<div className="captcha">
									<ReCAPTCHA
										sitekey="6LdazKkUAAAAAEtWME0kErnhhwZwvVqZEZs__UtO"
										onChange={this.onCaptcha}
										className="captcha"
									/>
								</div>
								<div className="buttonDabba">
									<button
										type="submit"
										className=" btn button"
									>
										{' '}
										<span id="subBut">Submit</span>
										<div
											className="submit spinner-border"
											id="loader"
											role="status"
										>
											<span className="sr-only" />
										</div>
									</button>
								</div>
							</form>
						</div>{' '}
					</div>
				</div>
				<Footer />
			</React.Fragment>
		)
	}
}

export default App
